import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';

export default class EmptyYesNoSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    fieldName: 'defaultFieldname',
    onChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  populateListData() {
    this.setState({
      selectValues: [
        { label: '', value: '', disabled: false },
        { label: 'Yes', value: true, disabled: false },
        { label: 'No', value: false, disabled: false },
      ],
    });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        selectValues={this.state.selectValues}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
      />
    );
  }
}
